import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IFactory } from 'src/core/interfaces/factory';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FactoryService {
  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) {}

  getFactories() {
    return this.http.get<any>(`${this._baseUrl}/factory/GetAll?isActive=1`);
  }
  getAllPaginated(
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null
  ) {
    return this.http.get<any>(
      `${this._baseUrl}/factory/paginated?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`
    );
  }
  getFactory(id: number) {
    return this.http.get<any>(`${this._baseUrl}/factory/${id}`);
  }
  deleteFactory(id: number) {
    return this.http.delete<any>(`${this._baseUrl}/factory/${id}`);
  }

  addFactory(factory: IFactory) {
    return this.http.post<any>(`${this._baseUrl}/factory/Add`, factory);
  }

  updateFactory(id: number, factory: IFactory) {
    return this.http.patch<any>(`${this._baseUrl}/factory/${id}`, factory);
  }

  deleteFactories(ids: number[]) {
    return this.http.delete<any>(`${this._baseUrl}/factory/delete/range`, {
      body: ids
    });
  }

  getPaginatedFactories(
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null,
    isActive = -1
  ) {
    return this.http.get<any>(
      `${this._baseUrl}/factory/paginated/${isActive}?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`
    );
  }

  getLastSapSync() {
    return this.http.get<any>(`${this._baseUrl}/Factory/LastSyncDate`);
  }

  getSapFactoriesSync() {
    return this.http.get<any>(`${this._baseUrl}/Factory/sync`);
  }
}
